import { RENDER_STATE_VERSION } from '../engine/rendering/RenderStateAdapter.js';
import { CANVAS_WORLD_RENDERER_VERSION } from '../rendering/CanvasWorldRenderer.js';

function assertMethod(value, method, name) {
  if (!value || typeof value[method] !== 'function') {
    throw new TypeError(`${name} must provide ${method}()`);
  }
}

export function installRenderingTestApi({
  baseApi,
  integration,
  windowRef = globalThis.window,
}) {
  if (!baseApi || typeof baseApi !== 'object') throw new TypeError('baseApi must be an object');
  assertMethod(integration, 'getStatus', 'integration');
  assertMethod(integration, 'captureRenderState', 'integration');
  assertMethod(integration, 'setDiagnostics', 'integration');
  assertMethod(integration, 'setCamera', 'integration');
  assertMethod(integration, 'showEngine2', 'integration');
  assertMethod(integration, 'showLegacy', 'integration');
  assertMethod(integration, 'exitPlayMode', 'integration');
  assertMethod(integration, 'renderNow', 'integration');
  assertMethod(integration, 'stopRenderer', 'integration');

  const baseCaptureSnapshot = typeof baseApi.captureSnapshot === 'function'
    ? baseApi.captureSnapshot.bind(baseApi)
    : null;

  const api = Object.freeze({
    ...baseApi,
    renderStateVersion: RENDER_STATE_VERSION,
    canvasRendererVersion: CANVAS_WORLD_RENDERER_VERSION,
    getRenderingStatus: () => integration.getStatus(),
    getRenderingDiagnostics: () => ({
      status: integration.getStatus(),
      renderState: integration.captureRenderState(),
    }),
    captureRenderState: () => integration.captureRenderState(),
    setRenderingDiagnostics: (options = {}) => ({
      ok: true,
      status: integration.setDiagnostics(options),
    }),
    setRenderingCamera: (options = {}) => ({
      ok: true,
      camera: integration.setCamera(options),
      status: integration.getStatus(),
    }),
    startEngine2Rendering: () => ({ ok: true, status: integration.showEngine2() }),
    showLegacyRendering: () => ({ ok: true, status: integration.showLegacy() }),
    exitRenderingPlayMode: () => ({ ok: true, status: integration.exitPlayMode() }),
    renderEngine2Frame: (timestamp = undefined) => ({
      ok: true,
      status: integration.renderNow(timestamp),
    }),
    stopEngine2Renderer: () => ({ ok: true, status: integration.stopRenderer() }),
    captureSnapshot: baseCaptureSnapshot === null
      ? undefined
      : () => ({
        ...baseCaptureSnapshot(),
        rendering: integration.getStatus(),
        renderState: integration.captureRenderState(),
      }),
  });

  Object.defineProperty(windowRef, '__SERPENT_TEST__', {
    configurable: true,
    enumerable: false,
    value: api,
  });

  return api;
}
